import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';

import { goBack } from 'core/routing';
import { staticURL } from 'core/url';

import { Wizard } from 'libs/wizards/index';
import DocumentHead from 'legacyComponents/documentHead';

import { clientStore } from 'apps/client/app';

import { NewInitiativeAppManager } from 'apps/initiative/newInitiative/appManager';

import Button from 'components/Button';
import Image from 'components/Image';
import {
  MainSignInPageWrapper,
  ImageWrapper,
  GoBackWrapper,
  WrapperSignInForm,
  MainSignInFormColumn,
} from 'apps/signIn/styles';

import Logo from 'components/Logo';

@withNamespaces()
@observer
export class NewInitiative extends React.Component {
  UNSAFE_componentWillMount() {
    if (clientStore.signedInProfile) {
      this.appManager = new NewInitiativeAppManager(this, this.props);
    } else {
      clientStore.routerStore.navigate('home.signIn', {
        next: clientStore.next(),
      });
    }
  }

  render() {
    const { t } = this.props;
    if (!this.appManager) {
      return null;
    }

    return (
      <>
        <DocumentHead title={t('New Initiative')} index='noindex' />
        <MainSignInPageWrapper>
          <GoBackWrapper>
            <Button
              outline
              variant='minimal'
              icon='close_small'
              size='small'
              onClick={() => goBack()}
            />
          </GoBackWrapper>
          <ImageWrapper>
            <Image
              src={staticURL('assets/gridImages/yellow-square-grid-light.svg')}
              alt='Grid image'
            />
          </ImageWrapper>
          <WrapperSignInForm>
            <MainSignInFormColumn>
              <Logo size='48px' />
              <Wizard
                isSideBarForm
                spacing='medium'
                wizard={this.appManager.newInitiativeApp.wizard}
              />
            </MainSignInFormColumn>
          </WrapperSignInForm>
        </MainSignInPageWrapper>
      </>
    );
  }
}

NewInitiative.propTypes = {
  t: PropTypes.func,
};
